module.exports = __webpack_public_path__ + "media/application/images/playbook-hero-bg-f293befd3f4e522d8bb3fb52d138e484.jpg";